// Positional types have no stable ids, so an array is replaced by index, and only when the lengths
// match. A mismatch keeps the English array, and a null entry keeps its English entry.
export const mergePositional = (english, translated) =>
  Array.isArray(english) && Array.isArray(translated) && english.length === translated.length
    ? english.map((entry, i) => translated[i] ?? entry)
    : english;
